/**
 * @generated SignedSource<<3c5a13b19834c7b3565579ef8cd2cb35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useToggleFontColor_page$data = {
  readonly fontColor: string | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useNoteWidgetStyleText_widgetNotePage">;
  readonly " $fragmentType": "useToggleFontColor_page";
};
export type useToggleFontColor_page$key = {
  readonly " $data"?: useToggleFontColor_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"useToggleFontColor_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useToggleFontColor_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontColor",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNoteWidgetStyleText_widgetNotePage"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "355b30cbe6a607f5fbb461559e296bb9";

export default node;
